import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export interface DateRange {
    startDate: Date;
    endDate: Date;
}

interface Props {
    value: DateRange;
    onChange: (range: DateRange) => void;
    maxDate?: Date;
}

export default function DateRangeSelector({ value, onChange, maxDate }: Props) {
    const { startDate, endDate } = value;

    function handleStart(date: Date | null) {
        if (!date) return;
        const start = moment(date).startOf('day').toDate();
        onChange({ startDate: start, endDate });
    }

    function handleEnd(date: Date | null) {
        if (!date) return;
        const end = moment(date).endOf('day').toDate();
        onChange({ startDate, endDate: end });
    }

    return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
            <div className="d-flex align-items-center gap-1">
                <label className="text-muted small mb-0" style={{ whiteSpace: "nowrap" }}>From</label>
                <DatePicker
                    selected={startDate}
                    onChange={handleStart}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    maxDate={endDate}
                    dateFormat="dd MMM yyyy"
                    className="form-control form-control-sm"
                />
            </div>
            <div className="d-flex align-items-center gap-1">
                <label className="text-muted small mb-0" style={{ whiteSpace: "nowrap" }}>To</label>
                <DatePicker
                    selected={endDate}
                    onChange={handleEnd}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    maxDate={maxDate ?? moment().endOf('day').toDate()}
                    dateFormat="dd MMM yyyy"
                    className="form-control form-control-sm"
                />
            </div>
        </div>
    );
}
